export const products = [
  {
    id: 1,
    handle: "bioderma-sebium-gel-moussant-100ml",
    title: "Bioderma Sebium Gel Moussant Soothing Purifying Gel, 100ml",
    vendor: "Bioderma",
    type: "Face Wash",
    tags: ["oily skin", "face wash", "bioderma", "purifying"],
    price: 489,
    compareAtPrice: 599,
    sku: "BIO-SEB-GEL-100",
    inventory: 45,
    images: [
      "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&q=80",
      "https://images.unsplash.com/photo-1617897903246-719242758050?w=400&q=80",
    ],
    description: "Bioderma Sebium Gel Moussant is a purifying foaming cleansing gel specifically formulated for oily and combination skin. With its patented Fluidactiv technology, it regulates sebum quality to prevent clogged pores and blemishes.",
    variants: [{ size: "100ml", price: 489 }, { size: "200ml", price: 799 }],
    collections: ["bestseller", "face-wash", "bioderma"],
    skinType: ["Oily", "Combination"],
    rating: 4.5,
    reviewCount: 312,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 2,
    handle: "cetaphil-gentle-skin-cleanser-500ml",
    title: "Cetaphil Gentle Skin Cleanser for Dry to Normal Skin, 500ml",
    vendor: "Cetaphil",
    type: "Face Wash",
    tags: ["dry skin", "normal skin", "face wash", "cetaphil", "gentle"],
    price: 699,
    compareAtPrice: 849,
    sku: "CET-GSC-500",
    inventory: 89,
    images: [
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&q=80",
      "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&q=80",
    ],
    description: "Cetaphil Gentle Skin Cleanser is a non-irritating, soap-free formula that gently removes dirt, makeup and impurities while maintaining skin's natural moisture barrier.",
    variants: [{ size: "125ml", price: 299 }, { size: "250ml", price: 499 }, { size: "500ml", price: 699 }],
    collections: ["bestseller", "face-wash", "cetaphil"],
    skinType: ["Dry", "Normal", "Sensitive"],
    rating: 4.7,
    reviewCount: 1024,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 3,
    handle: "cerave-moisturizing-cream-177ml",
    title: "CeraVe Moisturizing Cream for Normal to Dry Skin, 177ml",
    vendor: "CeraVe",
    type: "Moisturizer",
    tags: ["dry skin", "normal skin", "moisturizer", "cerave", "ceramides"],
    price: 849,
    compareAtPrice: 999,
    sku: "CVE-MC-177",
    inventory: 67,
    images: [
      "https://images.unsplash.com/photo-1611080626919-7cf5a9dbab12?w=400&q=80",
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=400&q=80",
    ],
    description: "CeraVe Moisturizing Cream is a rich, non-greasy cream developed with dermatologists. It contains three essential ceramides and hyaluronic acid to help restore and maintain the skin's natural barrier.",
    variants: [{ size: "177ml", price: 849 }, { size: "340ml", price: 1299 }],
    collections: ["bestseller", "moisturizer", "cerave"],
    skinType: ["Dry", "Normal"],
    rating: 4.8,
    reviewCount: 856,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 4,
    handle: "sesderma-acglicolic-classic-liposome-cream-50ml",
    title: "Sesderma Acglicolic Classic Liposome Cream, 50ml",
    vendor: "Sesderma",
    type: "Moisturizer",
    tags: ["anti-aging", "moisturizer", "sesderma", "glycolic acid", "combination"],
    price: 1899,
    compareAtPrice: 2299,
    sku: "SES-ACGLY-50",
    inventory: 23,
    images: [
      "https://images.unsplash.com/photo-1570554886111-e80fcca6a029?w=400&q=80",
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400&q=80",
    ],
    description: "Sesderma Acglicolic Classic Liposome Cream features glycolic acid encapsulated in liposomes for a progressive release that renews skin texture, reduces fine lines and improves radiance.",
    variants: [{ size: "50ml", price: 1899 }],
    collections: ["new-arrival", "moisturizer", "sesderma"],
    skinType: ["Normal", "Combination", "Oily"],
    rating: 4.4,
    reviewCount: 145,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 5,
    handle: "bioderma-photoderm-max-spf50-40ml",
    title: "Bioderma Photoderm MAX SPF 50+ Cream, 40ml",
    vendor: "Bioderma",
    type: "Sunscreen",
    tags: ["sunscreen", "spf50", "bioderma", "all skin types", "uva uvb"],
    price: 749,
    compareAtPrice: 899,
    sku: "BIO-PHD-MAX-50",
    inventory: 112,
    images: [
      "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=400&q=80",
      "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=400&q=80",
    ],
    description: "Bioderma Photoderm MAX SPF50+ provides very high protection against UVA, UVB, and visible light. With its Cellular Bioprotection system, it optimally protects all skin types.",
    variants: [{ size: "40ml", price: 749 }, { size: "100ml", price: 1299 }],
    collections: ["bestseller", "sunscreen", "bioderma"],
    skinType: ["All"],
    rating: 4.6,
    reviewCount: 432,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 6,
    handle: "fixderma-shadow-spf30-sunscreen-75g",
    title: "Fixderma Shadow SPF 30+ Sunscreen Gel, 75g",
    vendor: "Fixderma",
    type: "Sunscreen",
    tags: ["sunscreen", "spf30", "fixderma", "oily skin", "gel"],
    price: 349,
    compareAtPrice: 425,
    sku: "FIX-SHD-SPF30",
    inventory: 78,
    images: [
      "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&q=80",
      "https://images.unsplash.com/photo-1580870069867-74c57ee1bb07?w=400&q=80",
    ],
    description: "Fixderma Shadow SPF30+ is a lightweight, non-greasy sunscreen gel ideal for oily and acne-prone skin. It provides broad spectrum protection without clogging pores.",
    variants: [{ size: "75g", price: 349 }],
    collections: ["bestseller", "sunscreen", "fixderma"],
    skinType: ["Oily", "Acne-Prone"],
    rating: 4.3,
    reviewCount: 267,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 7,
    handle: "cerave-hydrating-facial-cleanser-236ml",
    title: "CeraVe Hydrating Facial Cleanser for Normal to Dry Skin, 236ml",
    vendor: "CeraVe",
    type: "Face Wash",
    tags: ["dry skin", "normal skin", "face wash", "cerave", "hydrating", "ceramides"],
    price: 799,
    compareAtPrice: 950,
    sku: "CVE-HFC-236",
    inventory: 54,
    images: [
      "https://images.unsplash.com/photo-1618842676088-c4d48a6a7571?w=400&q=80",
      "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&q=80",
    ],
    description: "CeraVe Hydrating Facial Cleanser gently cleanses and hydrates without disrupting the skin barrier. Formulated with hyaluronic acid, glycerin, and three essential ceramides.",
    variants: [{ size: "236ml", price: 799 }, { size: "473ml", price: 1299 }],
    collections: ["new-arrival", "face-wash", "cerave"],
    skinType: ["Dry", "Normal"],
    rating: 4.7,
    reviewCount: 589,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 8,
    handle: "cipla-ketoconazole-shampoo-100ml",
    title: "Cipla Ketoconazole Anti-Dandruff Shampoo, 100ml",
    vendor: "Cipla",
    type: "Shampoo",
    tags: ["shampoo", "anti-dandruff", "cipla", "ketoconazole", "scalp"],
    price: 189,
    compareAtPrice: 225,
    sku: "CIP-KTZ-SHP-100",
    inventory: 156,
    images: [
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&q=80",
      "https://images.unsplash.com/photo-1591019476829-6a9e49a0c35c?w=400&q=80",
    ],
    description: "Cipla Ketoconazole Shampoo contains 2% ketoconazole that effectively treats dandruff, seborrhoeic dermatitis, and tinea versicolor by targeting the fungal cause.",
    variants: [{ size: "100ml", price: 189 }],
    collections: ["bestseller", "shampoo", "cipla"],
    skinType: ["All Hair Types"],
    rating: 4.2,
    reviewCount: 834,
    isNew: false,
    isBestseller: false,
  },
  {
    id: 9,
    handle: "sebamed-clear-face-care-gel-50ml",
    title: "Sebamed Clear Face Care Gel for Acne-Prone Skin, 50ml",
    vendor: "Sebamed",
    type: "Moisturizer",
    tags: ["acne", "oily skin", "moisturizer", "sebamed", "oil-free"],
    price: 549,
    compareAtPrice: 649,
    sku: "SEB-CFC-GEL-50",
    inventory: 43,
    images: [
      "https://images.unsplash.com/photo-1570554886111-e80fcca6a029?w=400&q=80",
      "https://images.unsplash.com/photo-1590439471364-192aa70c0b53?w=400&q=80",
    ],
    description: "Sebamed Clear Face Care Gel is a pH 5.5 balanced, oil-free moisturizer for acne-prone and oily skin. Contains aloe vera and allantoin for soothing hydration without clogging pores.",
    variants: [{ size: "50ml", price: 549 }],
    collections: ["bestseller", "moisturizer", "sebamed"],
    skinType: ["Oily", "Acne-Prone"],
    rating: 4.5,
    reviewCount: 378,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 10,
    handle: "ivatherm-ceramel-cream-50ml",
    title: "Ivatherm Ceramel Hydrating Cream for Dry & Sensitive Skin, 50ml",
    vendor: "Ivatherm",
    type: "Moisturizer",
    tags: ["dry skin", "sensitive skin", "moisturizer", "ivatherm", "ceramides"],
    price: 1199,
    compareAtPrice: 1499,
    sku: "IVA-CRM-50",
    inventory: 29,
    images: [
      "https://images.unsplash.com/photo-1611080626919-7cf5a9dbab12?w=400&q=80",
      "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=400&q=80",
    ],
    description: "Ivatherm Ceramel Cream is enriched with ceramides and thermal spring water to deeply restore and maintain skin's protective barrier for very dry and sensitive skin.",
    variants: [{ size: "50ml", price: 1199 }, { size: "100ml", price: 1999 }],
    collections: ["new-arrival", "moisturizer", "ivatherm"],
    skinType: ["Dry", "Sensitive"],
    rating: 4.6,
    reviewCount: 112,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 11,
    handle: "clenia-foaming-face-wash-100ml",
    title: "Clenia Foaming Face Wash for Acne Control, 100ml",
    vendor: "Clenia",
    type: "Face Wash",
    tags: ["acne", "oily skin", "face wash", "clenia", "foaming"],
    price: 299,
    compareAtPrice: 375,
    sku: "CLN-FFW-100",
    inventory: 67,
    images: [
      "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&q=80",
      "https://images.unsplash.com/photo-1617897903246-719242758050?w=400&q=80",
    ],
    description: "Clenia Foaming Face Wash is an effective acne-fighting cleanser containing clindamycin and nicotinamide that reduces excess sebum and prevents breakouts.",
    variants: [{ size: "100ml", price: 299 }],
    collections: ["bestseller", "face-wash", "clenia"],
    skinType: ["Oily", "Acne-Prone"],
    rating: 4.1,
    reviewCount: 245,
    isNew: false,
    isBestseller: false,
  },
  {
    id: 12,
    handle: "cetaphil-sun-spf50-light-gel-100ml",
    title: "Cetaphil Sun SPF 50+ Light Gel Sunscreen, 100ml",
    vendor: "Cetaphil",
    type: "Sunscreen",
    tags: ["sunscreen", "spf50", "cetaphil", "sensitive skin", "light gel"],
    price: 899,
    compareAtPrice: 1099,
    sku: "CET-SUN-SPF50-100",
    inventory: 91,
    images: [
      "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=400&q=80",
      "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=400&q=80",
    ],
    description: "Cetaphil Sun SPF50+ Light Gel provides very high broad spectrum sun protection in a lightweight, non-greasy gel texture. Suitable for sensitive, oily, and combination skin.",
    variants: [{ size: "100ml", price: 899 }],
    collections: ["new-arrival", "sunscreen", "cetaphil"],
    skinType: ["Sensitive", "Oily", "Combination"],
    rating: 4.5,
    reviewCount: 341,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 13,
    handle: "fixderma-salyzap-cleanser-60ml",
    title: "Fixderma Salyzap Daily Face Wash with Salicylic Acid, 60ml",
    vendor: "Fixderma",
    type: "Face Wash",
    tags: ["acne", "oily skin", "face wash", "fixderma", "salicylic acid"],
    price: 279,
    compareAtPrice: 349,
    sku: "FIX-SLZ-CLN-60",
    inventory: 88,
    images: [
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&q=80",
      "https://images.unsplash.com/photo-1580870069867-74c57ee1bb07?w=400&q=80",
    ],
    description: "Fixderma Salyzap Daily Face Wash contains 0.5% Salicylic Acid and Tea Tree extracts that deeply cleanse pores and control excess oil for acne-prone and oily skin.",
    variants: [{ size: "60ml", price: 279 }],
    collections: ["bestseller", "face-wash", "fixderma"],
    skinType: ["Oily", "Acne-Prone", "Combination"],
    rating: 4.3,
    reviewCount: 456,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 14,
    handle: "bioderma-hydrabio-serum-40ml",
    title: "Bioderma Hydrabio Hyalu+ Serum for Dehydrated Skin, 40ml",
    vendor: "Bioderma",
    type: "Serum",
    tags: ["serum", "dehydrated skin", "bioderma", "hyaluronic acid", "hydration"],
    price: 1499,
    compareAtPrice: 1799,
    sku: "BIO-HYD-SER-40",
    inventory: 34,
    images: [
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400&q=80",
      "https://images.unsplash.com/photo-1570554886111-e80fcca6a029?w=400&q=80",
    ],
    description: "Bioderma Hydrabio Hyalu+ is a concentrated serum with 4 types of hyaluronic acid that intensely moisturizes and plumps dehydrated skin from the inside out.",
    variants: [{ size: "40ml", price: 1499 }],
    collections: ["new-arrival", "serum", "bioderma"],
    skinType: ["Dry", "Dehydrated", "Normal"],
    rating: 4.7,
    reviewCount: 189,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 15,
    handle: "cerave-vitamin-c-serum-30ml",
    title: "CeraVe Skin Renewing Vitamin C Serum, 30ml",
    vendor: "CeraVe",
    type: "Serum",
    tags: ["serum", "vitamin c", "cerave", "brightening", "anti-aging"],
    price: 1299,
    compareAtPrice: 1599,
    sku: "CVE-VTC-SER-30",
    inventory: 41,
    images: [
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400&q=80",
      "https://images.unsplash.com/photo-1611080626919-7cf5a9dbab12?w=400&q=80",
    ],
    description: "CeraVe Skin Renewing Vitamin C Serum brightens skin and improves the appearance of fine lines with 10% pure vitamin C (ascorbic acid) and three essential ceramides.",
    variants: [{ size: "30ml", price: 1299 }],
    collections: ["new-arrival", "serum", "cerave"],
    skinType: ["All", "Dull Skin"],
    rating: 4.6,
    reviewCount: 267,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 16,
    handle: "sebamed-baby-shampoo-150ml",
    title: "Sebamed Baby Shampoo with Camomile, 150ml",
    vendor: "Sebamed",
    type: "Shampoo",
    tags: ["baby", "shampoo", "sebamed", "gentle", "ph5.5"],
    price: 399,
    compareAtPrice: 499,
    sku: "SEB-BABY-SHP-150",
    inventory: 72,
    images: [
      "https://images.unsplash.com/photo-1591019476829-6a9e49a0c35c?w=400&q=80",
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&q=80",
    ],
    description: "Sebamed Baby Shampoo is a pH 5.5 balanced, tear-free formula enriched with camomile extract. Gently cleanses baby's delicate hair without causing irritation.",
    variants: [{ size: "150ml", price: 399 }, { size: "500ml", price: 999 }],
    collections: ["bestseller", "shampoo", "sebamed"],
    skinType: ["Baby", "Sensitive"],
    rating: 4.8,
    reviewCount: 623,
    isNew: false,
    isBestseller: false,
  },
  {
    id: 17,
    handle: "cipla-atarax-body-lotion-200ml",
    title: "Cipla Ezerra Intensely Moisturizing Body Cream, 100g",
    vendor: "Cipla",
    type: "Body Wash",
    tags: ["body", "moisturizer", "cipla", "dry skin", "eczema"],
    price: 449,
    compareAtPrice: 549,
    sku: "CIP-EZR-BODY-100",
    inventory: 55,
    images: [
      "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=400&q=80",
      "https://images.unsplash.com/photo-1570554886111-e80fcca6a029?w=400&q=80",
    ],
    description: "Cipla Ezerra Intensely Moisturizing Cream provides long-lasting hydration for dry, eczema-prone skin. Contains ceramides and natural moisturizing factors to restore the skin barrier.",
    variants: [{ size: "100g", price: 449 }],
    collections: ["bestseller", "body-wash", "cipla"],
    skinType: ["Dry", "Eczema-Prone"],
    rating: 4.4,
    reviewCount: 312,
    isNew: false,
    isBestseller: false,
  },
  {
    id: 18,
    handle: "sesderma-kojicol-plus-serum-30ml",
    title: "Sesderma Kojicol Plus Brightening Serum, 30ml",
    vendor: "Sesderma",
    type: "Serum",
    tags: ["serum", "brightening", "sesderma", "kojic acid", "pigmentation"],
    price: 2199,
    compareAtPrice: 2699,
    sku: "SES-KJC-SER-30",
    inventory: 18,
    images: [
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400&q=80",
      "https://images.unsplash.com/photo-1580870069867-74c57ee1bb07?w=400&q=80",
    ],
    description: "Sesderma Kojicol Plus is a depigmenting serum with kojic acid, phytic acid, and niacinamide in liposomes that effectively reduces dark spots, melasma, and uneven skin tone.",
    variants: [{ size: "30ml", price: 2199 }],
    collections: ["new-arrival", "serum", "sesderma"],
    skinType: ["All", "Pigmented Skin"],
    rating: 4.5,
    reviewCount: 89,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 19,
    handle: "fixderma-moisturizer-oily-skin-75g",
    title: "Fixderma Fizeek Oil Free Moisturizer for Oily Skin, 75g",
    vendor: "Fixderma",
    type: "Moisturizer",
    tags: ["oily skin", "moisturizer", "fixderma", "oil-free", "mattifying"],
    price: 299,
    compareAtPrice: 375,
    sku: "FIX-FZK-OFM-75",
    inventory: 94,
    images: [
      "https://images.unsplash.com/photo-1611080626919-7cf5a9dbab12?w=400&q=80",
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=400&q=80",
    ],
    description: "Fixderma Fizeek Oil Free Moisturizer is a lightweight, non-comedogenic formula that provides optimal hydration without adding shine to oily and acne-prone skin.",
    variants: [{ size: "75g", price: 299 }],
    collections: ["bestseller", "moisturizer", "fixderma"],
    skinType: ["Oily", "Acne-Prone"],
    rating: 4.2,
    reviewCount: 523,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 20,
    handle: "bioderma-cicabio-arnica-plus-cream-40ml",
    title: "Bioderma Cicabio Arnica+ Repairing Soothing Cream, 40ml",
    vendor: "Bioderma",
    type: "Moisturizer",
    tags: ["repair", "sensitive skin", "moisturizer", "bioderma", "soothing", "arnica"],
    price: 649,
    compareAtPrice: 799,
    sku: "BIO-CCA-CRM-40",
    inventory: 37,
    images: [
      "https://images.unsplash.com/photo-1570554886111-e80fcca6a029?w=400&q=80",
      "https://images.unsplash.com/photo-1611080626919-7cf5a9dbab12?w=400&q=80",
    ],
    description: "Bioderma Cicabio Arnica+ is a repairing cream with arnica and sucralfate that soothes irritated, damaged skin while accelerating the skin's natural healing process.",
    variants: [{ size: "40ml", price: 649 }, { size: "100ml", price: 1299 }],
    collections: ["bestseller", "moisturizer", "bioderma"],
    skinType: ["Sensitive", "Irritated"],
    rating: 4.6,
    reviewCount: 201,
    isNew: false,
    isBestseller: true,
  },
];

export const getProductByHandle = (handle) => products.find(p => p.handle === handle);
export const getProductsByCollection = (collection) => products.filter(p => p.collections.includes(collection));
export const getBestsellers = () => products.filter(p => p.isBestseller);
export const getNewArrivals = () => products.filter(p => p.isNew);
export const getProductsByType = (type) => products.filter(p => p.type === type);
export const getProductsByVendor = (vendor) => products.filter(p => p.vendor === vendor);
export const searchProducts = (query) => {
  const q = query.toLowerCase();
  return products.filter(p =>
    p.title.toLowerCase().includes(q) ||
    p.vendor.toLowerCase().includes(q) ||
    p.type.toLowerCase().includes(q) ||
    p.tags.some(t => t.includes(q))
  );
};
